module.exports = __webpack_public_path__ + "img/Search_white.87e5baa3.png";